module.exports = __webpack_public_path__ + "nc_static/media/card_edit.680569fd.svg";